import React from 'react';
import { InfoIcon } from 'src/assets/images';

type PromptProps = {
  text?: string;
  onClick?: () => void;
  className?: string;
  center?: boolean;
};

export function Prompt({ text, onClick, className, center }: PromptProps) {
  return (
    <section
      className={`flex gap-2 items-center cursor-pointer text-blue-600 text-xs ${className} ${
        center ? 'justify-center' : ''
      }
    ${onClick ? 'text-underline' : ''}`}
      onClick={onClick}
    >
      <img src={InfoIcon} alt="info" />
      <p>{text ? text : 'Why am I seeing this?'}</p>
    </section>
  );
}
